import React from 'react';
import { PRIVACY_URL, SOCIAL_URL, SUPPORT_EMAIL, TERMS_URL } from '../data/offer';
export function Footer() {
  return <footer className="w-full bg-ink text-white" data-id="element-111" data-mp="3ggtymjf7hl5r">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 py-12 sm:py-14" data-id="element-112" data-mp="32o4b2ak1486j">
        <div className="grid md:grid-cols-[1fr_auto] gap-8 md:items-end" data-id="element-113" data-mp="32lrlpcbxyvjg">
          <div data-id="element-114" data-mp="36pzblcu4yhj9">
            <p className="font-serif font-bold text-xl" data-id="element-115" data-mp="36ppn5toqoifo">Homeschool, Handled.</p>
            <p className="mt-2 text-sm text-white/70 max-w-md leading-relaxed" data-id="element-116" data-mp="3ugboz385h6h8">
              The operations layer for families who already homeschool — built
              for the weeks that go sideways.
            </p>
          </div>

          <ul className="flex flex-wrap gap-x-6 gap-y-2 text-sm text-white/80" data-id="element-117" data-mp="3lgomsf7ljwn4">
            <li data-id="element-118" data-mp="3qblzbw434o4r">
              <a href={`mailto:${SUPPORT_EMAIL}`} className="hover:text-white transition-colors duration-150" data-id="element-119" data-mp="3qf9nsguoakcm">
                {SUPPORT_EMAIL}
              </a>
            </li>
            <li data-id="element-120" data-mp="3l90l3octskvk">
              <a href={SOCIAL_URL} className="hover:text-white transition-colors duration-150" data-id="element-121" data-mp="3lalhzkmm4fwl">
                Instagram
              </a>
            </li>
            <li data-id="element-122" data-mp="3v8rflq1dyzvn">
              <a href={TERMS_URL} className="hover:text-white transition-colors duration-150" data-id="element-123" data-mp="3v9az3b6opwbs">
                Terms &amp; Conditions
              </a>
            </li>
            <li data-id="element-124" data-mp="80xjc6sbqxik">
              <a href={PRIVACY_URL} className="hover:text-white transition-colors duration-150" data-id="element-125" data-mp="33xd9vvh5urg">
                Privacy Policy
              </a>
            </li>
          </ul>
        </div>

        <p className="mt-10 pt-6 border-t border-white/15 text-xs text-white/50" data-id="element-126" data-mp="cth01cmb68rl">
          © 2026 Homeschool, Handled. All rights reserved.
        </p>
      </div>
    </footer>;
}